import CustomTable from "../../common/CustomTable";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import { editAttendanceShift } from "../../redux/actions/attendanceShifts";
import AttendanceStatus from "../AttendanceStatus";

const Attendance = ({ attendanceShift, pagination, onPageChange, onPageSizeChange, loading }) => {
  const dispatch = useDispatch();

  const formatTime = (timestamp) => {
    if (!timestamp) return "-";
    // Convert seconds → milliseconds
    const date = new Date(timestamp * 1000);
    return date.toISOString().substr(11, 8); // HH:MM:SS
  };

  const calculateTimeSpent = (timeIn, timeOut) => {
    if (!timeIn || !timeOut) return "-";
    const diff = Math.abs(timeOut - timeIn); // in seconds
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;
    return [hours, minutes, seconds].map((v) => String(v).padStart(2, "0")).join(":");
  };

  const columns = [
    { title: "Date", dataIndex: "date", render: (date) => (Array.isArray(date) ? date.join("/") : date), align: "center" },
    { title: "GeoFencing", dataIndex: "geofencingEnabled", render: (value) => (value ? "Yes" : "No"), align: "center" },
    { title: "Employee", dataIndex: "employeeName", align: "center" },
    { title: "Employee Id", dataIndex: "employeeCode", align: "center" },
    {
      title: "Time In",
      dataIndex: "timeIn",
      align: "center",
      render: (timeIn) => formatTime(timeIn),
    },
    {
      title: "Time Out",
      dataIndex: "timeOut",
      align: "center",
      render: (timeOut) => formatTime(timeOut),
    },
    {
      title: "Time Spent",
      render: (_, record) => calculateTimeSpent(record.timeIn, record.timeOut),
    },
    {
      title: "Attendance",
      dataIndex: "shiftStatus",
      align: "center",
      render: (status) => <AttendanceStatus status={status} />,
    },
    {
      title: "Completed By",
      align: "center",
      render: (_, record) =>
        record.shiftStatus === "COMPLETED"
          ? record.remarks || "Self"
          : "-",
    },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Button onClick={() => markAttendance(record)} disabled={record.shiftStatus === "COMPLETED"}>
          Mark Attendance
        </Button>
      ),
    },
  ];

  function markAttendance(record) {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    
    const { employeeName, ...rest } = record;
    console.log(currentUser);
    const formattedData = {
      ...rest,
      remarks: currentUser?.username,
      date: record.date.map((n) => String(n).padStart(2, "0")).join("-"),
      shiftStatus: "COMPLETED",
    };
    
    dispatch(editAttendanceShift(formattedData));
  }
  

  return (
    <div style={{ padding: "20px" }}>
      <h2>Shift Attendance Details</h2>
      {attendanceShift?.length > 0 ? (
        <CustomTable
          columns={columns}
          data={attendanceShift}
          loading={loading}
          pagination={pagination}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      ) : (
        <p>No Shifts Found</p>
      )}
    </div>
  );
};

export default Attendance;
